import React from 'react'
import { NavLink } from 'react-router-dom'
import { client } from 'redux/redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import * as config from 'styles/tailwind.config'

interface IProps extends RouteComponentProps {
  isLogout?: boolean
  linkTo?: string
  children: any
}

const NavItem: React.FC<IProps> = ({ history, isLogout, linkTo, children }) => {
  const [isActive, setActive] = React.useState<boolean>(false)

  const handleActive = (match: any, location: any) => {
    if (!match || !location.pathname.includes(match.url)) {
      setActive(false)
      return false
    }
    setActive(true)
    return true
  }

  const logout = () => {
    client.resetStore()
    localStorage.clear()
    window.location.href = '/'
  }

  if (isLogout) {
    return (
      <div className="h-full py-13 first-child:ml-0 ml-25">
        <li className="h-full flex items-center border-gray-200 border-l-1 pl-25">
          <button onClick={logout} className="opacity-50 font-400 text-black text-14 tracking-0.16">
            {children}
          </button>
        </li>
      </div>
    )
  }

  return (
    <li className="relative h-full flex items-center ml-30 first-child:ml-0">
      {isActive && <div className="absolute top-0 w-full h-3 bg-brand-primary" />}
      <NavLink
        activeStyle={{
          color: config.theme.colors.brand.primary,
        }}
        isActive={handleActive}
        className="h-full flex items-center font-400 text-black text-14 tracking-0.16"
        to={linkTo || '/'}
      >
        {children}
      </NavLink>
    </li>
  )
}

export default withRouter(NavItem)
